// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { Uuid, UuidT } from './uuid';
import { ValuedMessage, ValuedMessageT } from '../ln2/valued-message';


export class FrontEndMessage implements flatbuffers.IUnpackableObject<FrontEndMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):FrontEndMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsFrontEndMessage(bb:flatbuffers.ByteBuffer, obj?:FrontEndMessage):FrontEndMessage {
  return (obj || new FrontEndMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsFrontEndMessage(bb:flatbuffers.ByteBuffer, obj?:FrontEndMessage):FrontEndMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new FrontEndMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

bankId(obj?:Uuid):Uuid|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

liftId(obj?:Uuid):Uuid|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

msg(obj?:ValuedMessage):ValuedMessage|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new ValuedMessage()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startFrontEndMessage(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addBankId(builder:flatbuffers.Builder, bankIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, bankIdOffset, 0);
}

static addLiftId(builder:flatbuffers.Builder, liftIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, liftIdOffset, 0);
}

static addMsg(builder:flatbuffers.Builder, msgOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, msgOffset, 0);
}

static endFrontEndMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 4) // bank_id
  builder.requiredField(offset, 6) // lift_id
  builder.requiredField(offset, 8) // msg
  return offset;
}

static finishFrontEndMessageBuffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset);
}

static finishSizePrefixedFrontEndMessageBuffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset, undefined, true);
}


unpack(): FrontEndMessageT {
  return new FrontEndMessageT(
    (this.bankId() !== null ? this.bankId()!.unpack() : null),
    (this.liftId() !== null ? this.liftId()!.unpack() : null),
    (this.msg() !== null ? this.msg()!.unpack() : null)
  );
}


unpackTo(_o: FrontEndMessageT): void {
  _o.bankId = (this.bankId() !== null ? this.bankId()!.unpack() : null);
  _o.liftId = (this.liftId() !== null ? this.liftId()!.unpack() : null);
  _o.msg = (this.msg() !== null ? this.msg()!.unpack() : null);
}
}

export class FrontEndMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public bankId: UuidT|null = null,
  public liftId: UuidT|null = null,
  public msg: ValuedMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const bankId = (this.bankId !== null ? this.bankId!.pack(builder) : 0);
  const liftId = (this.liftId !== null ? this.liftId!.pack(builder) : 0);
  const msg = (this.msg !== null ? this.msg!.pack(builder) : 0);

  FrontEndMessage.startFrontEndMessage(builder);
  FrontEndMessage.addBankId(builder, bankId);
  FrontEndMessage.addLiftId(builder, liftId);
  FrontEndMessage.addMsg(builder, msg);

  return FrontEndMessage.endFrontEndMessage(builder);
}
}
